<script>
  export let bilder

  function getDesktopSrc(b) {
    return b.horisontal.crops.filter((el) => el.format === '8:3')[0].url
  }
  function getMobileSrc(b) {
    return b.horisontal.crops.filter((el) => el.format === '16:9')[0].url
  }

  function getDesktopSrcSet(b) {
    return getSrcSet(b.horisontal.crops.filter((el) => el.format === '8:3'))
  }
  function getMobileSrcSet(b) {
    return getSrcSet(b.horisontal.crops.filter((el) => el.format === '16:9'))
  }
  function getSrcSet(b) {
    return b.map((crops) => `${crops.url} ${crops.width}w`).join(', ')
  }
</script>

<style>
  img {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    height: 100%;
    width: 100%;
    border-radius: 6px 6px 0 0;
  }

  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }
  .aspect {
    overflow: hidden;
    position: relative;
    width: 100%;
    padding-top: calc((9 / 16) * 100%);
    border-radius: 6px 6px 0 0;
  }

  @media (min-width: 600px) {
    .aspect {
      padding-top: calc((3 / 7.9) * 100%);
    }
    .desktop {
      display: block;
    }

    .mobile {
      display: none;
    }
  }
</style>

<div class="aspect" style="background: {bilder.horisontal?.averageColor?.hex}">
  <img class="desktop" srcSet={getDesktopSrcSet(bilder)} src={getDesktopSrc(bilder)} alt="" />
  <img class="mobile" srcSet={getMobileSrcSet(bilder)} src={getMobileSrc(bilder)} alt="" />
</div>
